import {request} from '@/assets/js/request.js'
let productUrl='app20/product-service/product20/'

const getAccidentList = data => {
  return request({
    method: 'post',
    url: `${productUrl}api/trusteeship/queryAccidentDetail`,
    data: {
      d: data
    }
  })
}

const getRepairList = data => {
  return request({
    method: 'post',
    url: `${productUrl}api/trusteeship/queryRepairDetail`,
    data: {
      d: data
    }
  })
}

const getRepairDetail = data => {
  return request({
    method: 'post',
    url: `${productUrl}api/trusteeship/queryRepairDetailById`,
    data: {
      d: data
    }
  })
}

const getMaintainList = data => {
  return request({
    method: 'post',
    url: `${productUrl}api/trusteeship/queryMaintenanceDetail`,
    data: {
      d: data
    }
  })
}

const getMaintainDetail = data => {
  return request({
    method: 'post',
    url: `${productUrl}api/trusteeship/queryMaintenanceDetailById`,
    data: {
      d: data
    }
  })
}

const getViolationList = data => {
  return request({
    method: 'post',
    url: `${productUrl}api/trusteeship/queryViolationDetail`,
    data: {
      d: data
    }
  })
}

const getUpList = data => {
  return request({
    method: 'post',
    url: `${productUrl}api/trusteeship/violation/queryPage`,
    data: {
      d: data
    }
  })
}

const getUpDetail = id => {
  return request({
    method: 'get',
    url: `${productUrl}api/trusteeship/violation/getById/${id}`,
    data: {}
  })
}

//获取qiniutoken
const getQiNiuToken = data =>{
  return request({
    method: 'get',
    url: `app20/oss-service/oss/file2C/getQiNiuShortToken`,
    data: {},
  })
}

const violationAdd = data => {
  return request({
    method: 'post',
    url: `${productUrl}api/trusteeship/violation/add`,
    data: {
      d: data
    }
  })
}

const vehAddSuggest = data => {
  return request({
    method: 'post',
    url: `${productUrl}api/trusteeship/addSuggest`,
    data: {
      d: data
    }
  })
}

export {
  getAccidentList,
  getRepairList,
  getRepairDetail,
  getMaintainList,
  getMaintainDetail,
  getViolationList,
  getUpList,
  getUpDetail,
  getQiNiuToken,
  violationAdd,
  vehAddSuggest
}


// WEBPACK FOOTER //
// ./src/api/vehicleHandle.js